/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	apiAddress: 'http://conf.pulmoment.com',
	//apiAddress: 'http://conf.dev.pulmoment.com'
	//apiAddress: 'http://localhost:3333'
	firebaseConfig: {
		elektro: {
			appName: "Elektrotechnikai Vándorgyűlés",
			apiKey: "AIzaSyCB5uu-jFH_9bXKHNmpdiUNXWKT8RwsaHk",
			authDomain: "elektrovandor.firebaseapp.com",
			databaseURL: "https://elektrovandor.firebaseio.com",
			projectId: "elektrovandor",
			storageBucket: "elektrovandor.appspot.com",
			messagingSenderId: "546064351670"
		},
		uton: {
			appName: "ÚtOn",
			apiKey: "AIzaSyBDJ9C4VMxalRbUvLvY9MmL_ULQcnaKLA0",
			authDomain: "uton-f87e3.firebaseapp.com",
			databaseURL: "https://uton-f87e3.firebaseio.com",
			projectId: "uton-f87e3",
			storageBucket: "uton-f87e3.appspot.com",
			messagingSenderId: "450105260799"
		},
		safari: {
			appName: "Startup Safary",
			apiKey: "AIzaSyAA0jJvwucEXr0qOjPaVisyMBuRhrs_CpU",
			authDomain: "startupsafary2017.firebaseapp.com",
			databaseURL: "https://startupsafary2017.firebaseio.com",
			storageBucket: "startupsafary2017.appspot.com"
		},
		diakszinhaz: {
			appName: "Diákszínház",
			apiKey: "AIzaSyDToXSFyMMVvw_Bt_H9FHH2f-vJF8Qc58k",
			authDomain: "diakszinhaz-a5a99.firebaseapp.com",
			databaseURL: "https://diakszinhaz-a5a99.firebaseio.com",
			projectId: "diakszinhaz-a5a99",
			storageBucket: "diakszinhaz-a5a99.appspot.com",
			messagingSenderId: "967998939605"
		}
	},
	default: "diakszinhaz",
	ckeditor: {
			toolbar: [
				{ name: "document", items: ["Undo", "Redo"] },
				{
					name: "basicstyles",
					items: [
						"Bold",
						"Italic",
						"Underline",
						"Strike",
						"-",
						"RemoveFormat",
						"Source"
					]
				},
				{ name: "links", items: ["Link", "Unlink"] },
				{ name: "insert", items: ["Image", "Format", "Color"] }
			],
			clipboard_defaultContentType: "text",
			height: 300,
			language: "hu",
			removeButtons: "Underline,Subscript,Superscript",
			format_tags: "p;h1;h2;h3;pre",
			removeDialogTabs: "image:advanced;link:advanced"
	}
}




// WEBPACK FOOTER //
// ./src/config.js